import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewSampleBottle = ({ sampleBottle }) => {
  if (!sampleBottle) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Sample Bottle Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Sample Bottle Name: {sampleBottle.sampleBottleName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Description: {sampleBottle.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Inv Quantity: {sampleBottle.invQuantity}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewSampleBottle;
